import { render, staticRenderFns } from "./Marcas.vue?vue&type=template&id=764f9ee7&scoped=true&"
import script from "./Marcas.vue?vue&type=script&lang=js&"
export * from "./Marcas.vue?vue&type=script&lang=js&"
import style0 from "./Marcas.vue?vue&type=style&index=0&id=764f9ee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f9ee7",
  null
  
)

export default component.exports